// utilities
window._ = require('lodash');

// bootstrap
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');

// libraries
require('jquery-mask-plugin');
window.stickybits = require('stickybits');
//require('owl.carousel');
require('slick-carousel');
require('flickity');
window.axios = require('axios');
window.Noty = require('noty');
require('icheck');
require('lity');
window.number_format = require('locutus/php/strings/number_format');
window.round = require('locutus/php/math/round');
require('croppie');

// configuration
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
